// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file devtool/emodel/v1/im_model.proto (package devtool.emodel.v1, syntax proto3)
/* eslint-disable */

// A verbatim mirror of eModel's im_model.proto (enechain/service-proto,
// services/emodel/emodel/v1), in a package this repository owns: eposition-app's
// protos do not import another service's protos, but the dev-tool RPCs carry
// eModel requests and responses as their own.
//
// Field numbers and types match emodel.v1 exactly. That is what lets
// devtoolemodel.Convert translate by re-encoding instead of copying field by
// field, so any change to eModel's messages has to be mirrored here by hand —
// TestMirrorMatchesEmodel fails if the two ever drift.

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "./common_model_pb";
import { file_devtool_emodel_v1_common_model } from "./common_model_pb";
import type { Date } from "../../../google/type/date_pb";
import { file_google_type_date } from "../../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file devtool/emodel/v1/im_model.proto.
 */
export const file_devtool_emodel_v1_im_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_devtool_emodel_v1_common_model, file_google_type_date]);

/**
 * IMYearMonth represents year and month for contract expiry.
 *
 * @generated from message devtool.emodel.v1.IMYearMonth
 */
export type IMYearMonth = Message<"devtool.emodel.v1.IMYearMonth"> & {
  /**
   * @generated from field: uint32 year = 1;
   */
  year: number;

  /**
   * @generated from field: uint32 month = 2;
   */
  month: number;
};

/**
 * Describes the message devtool.emodel.v1.IMYearMonth.
 * Use `create(IMYearMonthSchema)` to create a new message.
 */
export const IMYearMonthSchema: GenMessage<IMYearMonth> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 0);

/**
 * IMPortfolioItem represents a single portfolio item for IM calculation.
 *
 * @generated from message devtool.emodel.v1.IMPortfolioItem
 */
export type IMPortfolioItem = Message<"devtool.emodel.v1.IMPortfolioItem"> & {
  /**
   * @generated from field: string account_code = 1;
   */
  accountCode: string;

  /**
   * @generated from field: devtool.emodel.v1.AreaCode area = 2;
   */
  area: AreaCode;

  /**
   * @generated from field: devtool.emodel.v1.IMHourType hour_type = 3;
   */
  hourType: IMHourType;

  /**
   * @generated from field: devtool.emodel.v1.IMPeriodType period_type = 4;
   */
  periodType: IMPeriodType;

  /**
   * @generated from field: devtool.emodel.v1.IMYearMonth contract_expiry = 5;
   */
  contractExpiry?: IMYearMonth;

  /**
   * @generated from field: double net_position_in_kw = 6;
   */
  netPositionInKw: number;

  /**
   * @generated from field: optional string floating_index_code = 7;
   */
  floatingIndexCode?: string;
};

/**
 * Describes the message devtool.emodel.v1.IMPortfolioItem.
 * Use `create(IMPortfolioItemSchema)` to create a new message.
 */
export const IMPortfolioItemSchema: GenMessage<IMPortfolioItem> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 1);

/**
 * IMBreakdownItemPower represents a breakdown item for power IM.
 *
 * @generated from message devtool.emodel.v1.IMBreakdownItemPower
 */
export type IMBreakdownItemPower = Message<"devtool.emodel.v1.IMBreakdownItemPower"> & {
  /**
   * @generated from field: devtool.emodel.v1.AreaCode area = 1;
   */
  area: AreaCode;

  /**
   * @generated from field: devtool.emodel.v1.IMHourType hour_type = 2;
   */
  hourType: IMHourType;

  /**
   * @generated from field: devtool.emodel.v1.IMPeriodType period_type = 3;
   */
  periodType: IMPeriodType;

  /**
   * @generated from field: devtool.emodel.v1.IMYearMonth contract_expiry = 4;
   */
  contractExpiry?: IMYearMonth;

  /**
   * @generated from field: double quantity_in_kw = 5;
   */
  quantityInKw: number;

  /**
   * @generated from field: double price_scan_range = 6;
   */
  priceScanRange: number;

  /**
   * @generated from field: double initial_margin = 7;
   */
  initialMargin: number;

  /**
   * @generated from field: double ics_credit = 8;
   */
  icsCredit: number;
};

/**
 * Describes the message devtool.emodel.v1.IMBreakdownItemPower.
 * Use `create(IMBreakdownItemPowerSchema)` to create a new message.
 */
export const IMBreakdownItemPowerSchema: GenMessage<IMBreakdownItemPower> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 2);

/**
 * IMBreakdownItemFloatingIndex represents a breakdown item for floating index IM.
 *
 * @generated from message devtool.emodel.v1.IMBreakdownItemFloatingIndex
 */
export type IMBreakdownItemFloatingIndex = Message<"devtool.emodel.v1.IMBreakdownItemFloatingIndex"> & {
  /**
   * @generated from field: string floating_index_code = 1;
   */
  floatingIndexCode: string;

  /**
   * @generated from field: devtool.emodel.v1.IMPeriodType period_type = 2;
   */
  periodType: IMPeriodType;

  /**
   * @generated from field: devtool.emodel.v1.IMYearMonth contract_expiry = 3;
   */
  contractExpiry?: IMYearMonth;

  /**
   * @generated from field: double quantity_in_kw = 4;
   */
  quantityInKw: number;

  /**
   * @generated from field: double price_scan_range = 5;
   */
  priceScanRange: number;

  /**
   * @generated from field: double initial_margin = 6;
   */
  initialMargin: number;
};

/**
 * Describes the message devtool.emodel.v1.IMBreakdownItemFloatingIndex.
 * Use `create(IMBreakdownItemFloatingIndexSchema)` to create a new message.
 */
export const IMBreakdownItemFloatingIndexSchema: GenMessage<IMBreakdownItemFloatingIndex> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 3);

/**
 * IMPortfolioResult represents the IM calculation result for a portfolio.
 *
 * @generated from message devtool.emodel.v1.IMPortfolioResult
 */
export type IMPortfolioResult = Message<"devtool.emodel.v1.IMPortfolioResult"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string account_code = 2;
   */
  accountCode: string;

  /**
   * @generated from field: google.type.Date calculation_date = 3;
   */
  calculationDate?: Date;

  /**
   * @generated from field: string currency_code = 4;
   */
  currencyCode: string;

  /**
   * @generated from field: double total_initial_margin = 5;
   */
  totalInitialMargin: number;

  /**
   * @generated from field: double power_initial_margin = 6;
   */
  powerInitialMargin: number;

  /**
   * @generated from field: double floating_index_initial_margin = 7;
   */
  floatingIndexInitialMargin: number;

  /**
   * @generated from field: repeated devtool.emodel.v1.IMBreakdownItemPower power_breakdown = 8;
   */
  powerBreakdown: IMBreakdownItemPower[];

  /**
   * @generated from field: repeated devtool.emodel.v1.IMBreakdownItemFloatingIndex floating_index_breakdown = 9;
   */
  floatingIndexBreakdown: IMBreakdownItemFloatingIndex[];
};

/**
 * Describes the message devtool.emodel.v1.IMPortfolioResult.
 * Use `create(IMPortfolioResultSchema)` to create a new message.
 */
export const IMPortfolioResultSchema: GenMessage<IMPortfolioResult> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 4);

/**
 * PSRData represents PSR data used in calculation (for response).
 *
 * @generated from message devtool.emodel.v1.PSRData
 */
export type PSRData = Message<"devtool.emodel.v1.PSRData"> & {
  /**
   * @generated from field: devtool.emodel.v1.AreaCode area = 1;
   */
  area: AreaCode;

  /**
   * @generated from field: devtool.emodel.v1.IMHourType hour_type = 2;
   */
  hourType: IMHourType;

  /**
   * @generated from field: devtool.emodel.v1.IMPeriodType period_type = 3;
   */
  periodType: IMPeriodType;

  /**
   * @generated from field: devtool.emodel.v1.IMYearMonth contract_expiry = 4;
   */
  contractExpiry?: IMYearMonth;

  /**
   * @generated from field: double price_scan_range = 5;
   */
  priceScanRange: number;

  /**
   * @generated from field: google.type.Date trade_date = 6;
   */
  tradeDate?: Date;

  /**
   * @generated from field: string currency = 7;
   */
  currency: string;
};

/**
 * Describes the message devtool.emodel.v1.PSRData.
 * Use `create(PSRDataSchema)` to create a new message.
 */
export const PSRDataSchema: GenMessage<PSRData> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 5);

/**
 * ICSData represents ICS data used in calculation (for response).
 *
 * @generated from message devtool.emodel.v1.ICSData
 */
export type ICSData = Message<"devtool.emodel.v1.ICSData"> & {
  /**
   * @generated from field: devtool.emodel.v1.AreaCode area = 1;
   */
  area: AreaCode;

  /**
   * @generated from field: devtool.emodel.v1.IMHourType hour_type = 2;
   */
  hourType: IMHourType;

  /**
   * @generated from field: devtool.emodel.v1.IMPeriodType period_type = 3;
   */
  periodType: IMPeriodType;

  /**
   * @generated from field: devtool.emodel.v1.IMYearMonth contract_expiry = 4;
   */
  contractExpiry?: IMYearMonth;

  /**
   * @generated from field: double ics_rate = 5;
   */
  icsRate: number;

  /**
   * @generated from field: google.type.Date trade_date = 6;
   */
  tradeDate?: Date;
};

/**
 * Describes the message devtool.emodel.v1.ICSData.
 * Use `create(ICSDataSchema)` to create a new message.
 */
export const ICSDataSchema: GenMessage<ICSData> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 6);

/**
 * PSRDataForFloatingIndex represents PSR data for floating index (for response).
 *
 * @generated from message devtool.emodel.v1.PSRDataForFloatingIndex
 */
export type PSRDataForFloatingIndex = Message<"devtool.emodel.v1.PSRDataForFloatingIndex"> & {
  /**
   * @generated from field: string floating_index_code = 1;
   */
  floatingIndexCode: string;

  /**
   * @generated from field: devtool.emodel.v1.IMPeriodType period_type = 2;
   */
  periodType: IMPeriodType;

  /**
   * @generated from field: devtool.emodel.v1.IMYearMonth contract_expiry = 3;
   */
  contractExpiry?: IMYearMonth;

  /**
   * @generated from field: double price_scan_range = 4;
   */
  priceScanRange: number;

  /**
   * @generated from field: google.type.Date trade_date = 5;
   */
  tradeDate?: Date;

  /**
   * @generated from field: string currency = 6;
   */
  currency: string;
};

/**
 * Describes the message devtool.emodel.v1.PSRDataForFloatingIndex.
 * Use `create(PSRDataForFloatingIndexSchema)` to create a new message.
 */
export const PSRDataForFloatingIndexSchema: GenMessage<PSRDataForFloatingIndex> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 7);

/**
 * Floating IMポジションエントリ
 *
 * @generated from message devtool.emodel.v1.FloatingIMPositionEntry
 */
export type FloatingIMPositionEntry = Message<"devtool.emodel.v1.FloatingIMPositionEntry"> & {
  /**
   * 口座コード
   *
   * @generated from field: string account_code = 1;
   */
  accountCode: string;

  /**
   * エリア
   *
   * @generated from field: devtool.emodel.v1.AreaCode area = 2;
   */
  area: AreaCode;

  /**
   * 時間帯タイプ
   *
   * @generated from field: string hour_type = 3;
   */
  hourType: string;

  /**
   * 期間タイプ（Month/Quarter/Season/FiscalYear）
   *
   * @generated from field: string period_type = 4;
   */
  periodType: string;

  /**
   * 受渡期限（yyyymm形式）
   *
   * @generated from field: string expiry = 5;
   */
  expiry: string;

  /**
   * Floating Index Code（電力ポジションの場合は空文字可）
   *
   * @generated from field: string floating_index_code = 6;
   */
  floatingIndexCode: string;

  /**
   * 正味ポジション（正=買い、負=売り）
   *
   * @generated from field: double net_position = 7;
   */
  netPosition: number;
};

/**
 * Describes the message devtool.emodel.v1.FloatingIMPositionEntry.
 * Use `create(FloatingIMPositionEntrySchema)` to create a new message.
 */
export const FloatingIMPositionEntrySchema: GenMessage<FloatingIMPositionEntry> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 8);

/**
 * インデックス別IM
 *
 * @generated from message devtool.emodel.v1.FloatingIMByIndex
 */
export type FloatingIMByIndex = Message<"devtool.emodel.v1.FloatingIMByIndex"> & {
  /**
   * Floating Index Code
   *
   * @generated from field: string floating_index_code = 1;
   */
  floatingIndexCode: string;

  /**
   * 個別IM
   *
   * @generated from field: double individual_im = 2;
   */
  individualIm: number;
};

/**
 * Describes the message devtool.emodel.v1.FloatingIMByIndex.
 * Use `create(FloatingIMByIndexSchema)` to create a new message.
 */
export const FloatingIMByIndexSchema: GenMessage<FloatingIMByIndex> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 9);

/**
 * 口座別IM
 *
 * @generated from message devtool.emodel.v1.FloatingIMByAccount
 */
export type FloatingIMByAccount = Message<"devtool.emodel.v1.FloatingIMByAccount"> & {
  /**
   * 口座コード
   *
   * @generated from field: string account_code = 1;
   */
  accountCode: string;

  /**
   * IM
   *
   * @generated from field: double im = 2;
   */
  im: number;
};

/**
 * Describes the message devtool.emodel.v1.FloatingIMByAccount.
 * Use `create(FloatingIMByAccountSchema)` to create a new message.
 */
export const FloatingIMByAccountSchema: GenMessage<FloatingIMByAccount> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 10);

/**
 * 口座別電力IM
 *
 * @generated from message devtool.emodel.v1.PowerIMByAccount
 */
export type PowerIMByAccount = Message<"devtool.emodel.v1.PowerIMByAccount"> & {
  /**
   * 口座コード
   *
   * @generated from field: string account_code = 1;
   */
  accountCode: string;

  /**
   * IM
   *
   * @generated from field: double im = 2;
   */
  im: number;
};

/**
 * Describes the message devtool.emodel.v1.PowerIMByAccount.
 * Use `create(PowerIMByAccountSchema)` to create a new message.
 */
export const PowerIMByAccountSchema: GenMessage<PowerIMByAccount> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 11);

/**
 * Floating IM 結果（CVaR historical simulation）
 *
 * @generated from message devtool.emodel.v1.FloatingIMResult
 */
export type FloatingIMResult = Message<"devtool.emodel.v1.FloatingIMResult"> & {
  /**
   * 合計Floating IM
   *
   * @generated from field: double total_im = 1;
   */
  totalIm: number;

  /**
   * インデックス別IM
   *
   * @generated from field: repeated devtool.emodel.v1.FloatingIMByIndex im_by_index = 2;
   */
  imByIndex: FloatingIMByIndex[];

  /**
   * 口座別IM
   *
   * @generated from field: repeated devtool.emodel.v1.FloatingIMByAccount im_by_account = 3;
   */
  imByAccount: FloatingIMByAccount[];

  /**
   * 使用されたパーセンタイル（basis points単位）
   *
   * @generated from field: int32 used_percentile_bps = 4;
   */
  usedPercentileBps: number;

  /**
   * 使用された観測期間
   *
   * @generated from field: int32 used_observation_period = 5;
   */
  usedObservationPeriod: number;

  /**
   * 使用された調整係数
   *
   * @generated from field: double used_adjustment_factor = 6;
   */
  usedAdjustmentFactor: number;
};

/**
 * Describes the message devtool.emodel.v1.FloatingIMResult.
 * Use `create(FloatingIMResultSchema)` to create a new message.
 */
export const FloatingIMResultSchema: GenMessage<FloatingIMResult> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 12);

/**
 * 電力 IM 結果（SPAN/PSR-based）
 *
 * @generated from message devtool.emodel.v1.PowerIMResult
 */
export type PowerIMResult = Message<"devtool.emodel.v1.PowerIMResult"> & {
  /**
   * 合計電力IM
   *
   * @generated from field: double total_im = 1;
   */
  totalIm: number;

  /**
   * 電力コンポーネント
   *
   * @generated from field: double power_component = 2;
   */
  powerComponent: number;

  /**
   * Floating Indexコンポーネント
   *
   * @generated from field: double floating_index_component = 3;
   */
  floatingIndexComponent: number;

  /**
   * 電力IM内訳
   *
   * @generated from field: repeated devtool.emodel.v1.IMBreakdownItemPower power_breakdown = 4;
   */
  powerBreakdown: IMBreakdownItemPower[];

  /**
   * Floating Index IM内訳
   *
   * @generated from field: repeated devtool.emodel.v1.IMBreakdownItemFloatingIndex floating_index_breakdown = 5;
   */
  floatingIndexBreakdown: IMBreakdownItemFloatingIndex[];

  /**
   * 口座別電力IM
   *
   * @generated from field: repeated devtool.emodel.v1.PowerIMByAccount im_by_account = 6;
   */
  imByAccount: PowerIMByAccount[];

  /**
   * SPAN V2 詳細結果
   *
   * @generated from field: optional devtool.emodel.v1.SPANV2Result span_v2_result = 7;
   */
  spanV2Result?: SPANV2Result;
};

/**
 * Describes the message devtool.emodel.v1.PowerIMResult.
 * Use `create(PowerIMResultSchema)` to create a new message.
 */
export const PowerIMResultSchema: GenMessage<PowerIMResult> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 13);

/**
 * SPAN V2 ポジション別計算詳細
 *
 * @generated from message devtool.emodel.v1.SPANV2BreakdownItem
 */
export type SPANV2BreakdownItem = Message<"devtool.emodel.v1.SPANV2BreakdownItem"> & {
  /**
   * エリア
   *
   * @generated from field: devtool.emodel.v1.AreaCode area = 1;
   */
  area: AreaCode;

  /**
   * 時間帯タイプ
   *
   * @generated from field: devtool.emodel.v1.IMHourType hour_type = 2;
   */
  hourType: IMHourType;

  /**
   * 期間タイプ
   *
   * @generated from field: devtool.emodel.v1.IMPeriodType period_type = 3;
   */
  periodType: IMPeriodType;

  /**
   * 受渡期限
   *
   * @generated from field: devtool.emodel.v1.IMYearMonth contract_expiry = 4;
   */
  contractExpiry?: IMYearMonth;

  /**
   * ポジション数量（kW）
   *
   * @generated from field: double quantity_in_kw = 5;
   */
  quantityInKw: number;

  /**
   * PSR（JPY/kW）
   *
   * @generated from field: double psr = 6;
   */
  psr: number;

  /**
   * Scan Risk = PSR * |qty|
   *
   * @generated from field: double scan_risk = 7;
   */
  scanRisk: number;

  /**
   * このポジションに按分されたスプレッドクレジット（種別合算、scan-risk 比率で配分）
   *
   * @generated from field: double spread_credit = 12;
   */
  spreadCredit: number;

  /**
   * 最終配分IM
   *
   * @generated from field: double initial_margin = 13;
   */
  initialMargin: number;
};

/**
 * Describes the message devtool.emodel.v1.SPANV2BreakdownItem.
 * Use `create(SPANV2BreakdownItemSchema)` to create a new message.
 */
export const SPANV2BreakdownItemSchema: GenMessage<SPANV2BreakdownItem> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 14);

/**
 * SPAN V2 クレジットを生んだスプレッドペア（credit > 0 のみ）
 *
 * @generated from message devtool.emodel.v1.SPANV2SpreadPair
 */
export type SPANV2SpreadPair = Message<"devtool.emodel.v1.SPANV2SpreadPair"> & {
  /**
   * Leg A
   *
   * @generated from field: devtool.emodel.v1.AreaCode leg_a_area = 1;
   */
  legAArea: AreaCode;

  /**
   * @generated from field: devtool.emodel.v1.IMHourType leg_a_hour_type = 2;
   */
  legAHourType: IMHourType;

  /**
   * @generated from field: devtool.emodel.v1.IMPeriodType leg_a_period_type = 3;
   */
  legAPeriodType: IMPeriodType;

  /**
   * @generated from field: devtool.emodel.v1.IMYearMonth leg_a_expiry = 4;
   */
  legAExpiry?: IMYearMonth;

  /**
   * Leg B
   *
   * @generated from field: devtool.emodel.v1.AreaCode leg_b_area = 5;
   */
  legBArea: AreaCode;

  /**
   * @generated from field: devtool.emodel.v1.IMHourType leg_b_hour_type = 6;
   */
  legBHourType: IMHourType;

  /**
   * @generated from field: devtool.emodel.v1.IMPeriodType leg_b_period_type = 7;
   */
  legBPeriodType: IMPeriodType;

  /**
   * @generated from field: devtool.emodel.v1.IMYearMonth leg_b_expiry = 8;
   */
  legBExpiry?: IMYearMonth;

  /**
   * ペア種別: "intra" | "inter_fy" | "inter_non_fy"
   *
   * @generated from field: string kind = 9;
   */
  kind: string;

  /**
   * パラメータ出典: "ecc" | "synthetic_area" | "synthetic_tenor" | "synthetic_area_tenor" | "self_pair" | "unspecified"
   *
   * @generated from field: string source = 10;
   */
  source: string;

  /**
   * 各レグで消費した数量（kW）
   *
   * @generated from field: double consumed_a_kw = 11;
   */
  consumedAKw: number;

  /**
   * @generated from field: double consumed_b_kw = 12;
   */
  consumedBKw: number;

  /**
   * クレジット（JPY）= credit_a + credit_b
   *
   * @generated from field: double credit = 13;
   */
  credit: number;

  /**
   * 各レグの PSR（クレジット式の入力。breakdown と同じ値）
   *
   * @generated from field: double psr_a = 14;
   */
  psrA: number;

  /**
   * @generated from field: double psr_b = 15;
   */
  psrB: number;

  /**
   * スプレッド比率（Ratio 系のみ使用。min-IM 系では未使用）
   *
   * @generated from field: double ratio_a = 16;
   */
  ratioA: number;

  /**
   * @generated from field: double ratio_b = 17;
   */
  ratioB: number;

  /**
   * クレジット率 CR
   *
   * @generated from field: double credit_rate = 18;
   */
  creditRate: number;

  /**
   * このペア処理直前の各レグ残量（kW）= match の入力
   *
   * @generated from field: double rem_a_kw = 19;
   */
  remAKw: number;

  /**
   * @generated from field: double rem_b_kw = 20;
   */
  remBKw: number;
};

/**
 * Describes the message devtool.emodel.v1.SPANV2SpreadPair.
 * Use `create(SPANV2SpreadPairSchema)` to create a new message.
 */
export const SPANV2SpreadPairSchema: GenMessage<SPANV2SpreadPair> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 15);

/**
 * SPAN V2 計算結果（EEX SPAN モデル）
 *
 * @generated from message devtool.emodel.v1.SPANV2Result
 */
export type SPANV2Result = Message<"devtool.emodel.v1.SPANV2Result"> & {
  /**
   * ポジション別内訳（型不変のため番号 8 を維持）
   *
   * @generated from field: repeated devtool.emodel.v1.SPANV2BreakdownItem breakdown = 8;
   */
  breakdown: SPANV2BreakdownItem[];

  /**
   * Net IM = Gross Margin − Total Spread Credit
   *
   * @generated from field: double net_im = 9;
   */
  netIm: number;

  /**
   * Gross Margin = Σ(PSR × |q|)
   *
   * @generated from field: double gross_margin = 10;
   */
  grossMargin: number;

  /**
   * Total Spread Credit = Σ ペア別クレジット（全種別）
   *
   * @generated from field: double total_spread_credit = 11;
   */
  totalSpreadCredit: number;

  /**
   * 種別小計（3 つの合計が total_spread_credit に一致）
   *
   * @generated from field: double intra_spread_credit = 12;
   */
  intraSpreadCredit: number;

  /**
   * @generated from field: double inter_fy_spread_credit = 13;
   */
  interFySpreadCredit: number;

  /**
   * @generated from field: double inter_non_fy_spread_credit = 14;
   */
  interNonFySpreadCredit: number;

  /**
   * ペア別クレジット明細（credit > 0 のみ）
   *
   * @generated from field: repeated devtool.emodel.v1.SPANV2SpreadPair spread_pairs = 15;
   */
  spreadPairs: SPANV2SpreadPair[];

  /**
   * 実際に使ったスプレッドクレジットの方式。
   * リクエストで未指定の場合は SPAN_V2_SPREAD_CREDIT_METHOD_ABSOLUTE_QUANTITY（v1.0）が入る。
   *
   * @generated from field: devtool.emodel.v1.SpanV2SpreadCreditMethod spread_credit_method = 16;
   */
  spreadCreditMethod: SpanV2SpreadCreditMethod;
};

/**
 * Describes the message devtool.emodel.v1.SPANV2Result.
 * Use `create(SPANV2ResultSchema)` to create a new message.
 */
export const SPANV2ResultSchema: GenMessage<SPANV2Result> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 16);

/**
 * アカウント別の IM 結果
 *
 * @generated from message devtool.emodel.v1.AccountIMResult
 */
export type AccountIMResult = Message<"devtool.emodel.v1.AccountIMResult"> & {
  /**
   * 口座コード
   *
   * @generated from field: string account_code = 1;
   */
  accountCode: string;

  /**
   * Floating IM 結果（CVaR historical simulation）
   *
   * @generated from field: devtool.emodel.v1.FloatingIMResult floating_im = 2;
   */
  floatingIm?: FloatingIMResult;

  /**
   * 電力 IM 結果（SPAN/PSR-based）
   *
   * @generated from field: devtool.emodel.v1.PowerIMResult power_im = 3;
   */
  powerIm?: PowerIMResult;
};

/**
 * Describes the message devtool.emodel.v1.AccountIMResult.
 * Use `create(AccountIMResultSchema)` to create a new message.
 */
export const AccountIMResultSchema: GenMessage<AccountIMResult> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 17);

/**
 * ICSTargetProduct specifies an area + hour_type pair for ICS target filtering.
 *
 * @generated from message devtool.emodel.v1.ICSTargetProduct
 */
export type ICSTargetProduct = Message<"devtool.emodel.v1.ICSTargetProduct"> & {
  /**
   * @generated from field: devtool.emodel.v1.AreaCode area = 1;
   */
  area: AreaCode;

  /**
   * @generated from field: devtool.emodel.v1.IMHourType hour_type = 2;
   */
  hourType: IMHourType;
};

/**
 * Describes the message devtool.emodel.v1.ICSTargetProduct.
 * Use `create(ICSTargetProductSchema)` to create a new message.
 */
export const ICSTargetProductSchema: GenMessage<ICSTargetProduct> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 18);

/**
 * PSRRecord represents a single PSR row in ECC short-code form.
 *
 * @generated from message devtool.emodel.v1.PSRRecord
 */
export type PSRRecord = Message<"devtool.emodel.v1.PSRRecord"> & {
  /**
   * ECC combined commodity short code, e.g. "FOBM" (tokyo+base+month).
   *
   * @generated from field: string product_id = 1;
   */
  productId: string;

  /**
   * @generated from field: uint32 year = 2;
   */
  year: number;

  /**
   * @generated from field: uint32 month = 3;
   */
  month: number;

  /**
   * PSR in JPY/MW (same unit and precision as the source row).
   *
   * @generated from field: double psr = 4;
   */
  psr: number;
};

/**
 * Describes the message devtool.emodel.v1.PSRRecord.
 * Use `create(PSRRecordSchema)` to create a new message.
 */
export const PSRRecordSchema: GenMessage<PSRRecord> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 19);

/**
 * SpreadRecord represents a single ECC inter-commodity spread row in ECC short-code form.
 *
 * @generated from message devtool.emodel.v1.SpreadRecord
 */
export type SpreadRecord = Message<"devtool.emodel.v1.SpreadRecord"> & {
  /**
   * @generated from field: string commodity_a = 1;
   */
  commodityA: string;

  /**
   * @generated from field: uint32 year_a = 2;
   */
  yearA: number;

  /**
   * @generated from field: uint32 month_a = 3;
   */
  monthA: number;

  /**
   * @generated from field: string commodity_b = 4;
   */
  commodityB: string;

  /**
   * @generated from field: uint32 year_b = 5;
   */
  yearB: number;

  /**
   * @generated from field: uint32 month_b = 6;
   */
  monthB: number;

  /**
   * @generated from field: double ratio_a = 7;
   */
  ratioA: number;

  /**
   * @generated from field: double ratio_b = 8;
   */
  ratioB: number;

  /**
   * @generated from field: double credit_rate = 9;
   */
  creditRate: number;
};

/**
 * Describes the message devtool.emodel.v1.SpreadRecord.
 * Use `create(SpreadRecordSchema)` to create a new message.
 */
export const SpreadRecordSchema: GenMessage<SpreadRecord> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 20);

/**
 * RawPosition represents a single portfolio position. The same message type is
 * used for both raw_positions (pre-normalization input as submitted by the
 * caller) and normalized_positions (after 9-area mapping and listing-window
 * clamping); the field-level semantics differ per usage and are documented on
 * CalculationInput.
 *
 * @generated from message devtool.emodel.v1.RawPosition
 */
export type RawPosition = Message<"devtool.emodel.v1.RawPosition"> & {
  /**
   * Lowercase area. For raw_positions: any of the 9 areas
   * (hokkaido / tohoku / tokyo / chubu / hokuriku / kansai / chugoku / shikoku /
   * kyushu). For normalized_positions: collapsed to 3-area
   * ("tokyo" / "chubu" / "kansai").
   *
   * @generated from field: string area = 1;
   */
  area: string;

  /**
   * Lowercase: "base" / "peak".
   *
   * @generated from field: string hour_type = 2;
   */
  hourType: string;

  /**
   * Lowercase + underscore: "month" / "quarter" / "season" / "fiscal_year" / "calendar_year".
   *
   * @generated from field: string period_type = 3;
   */
  periodType: string;

  /**
   * ISO 8601 date (YYYY-MM-DD), e.g. "2026-05-01". For raw_positions: the
   * delivery start of the original input. For normalized_positions: projected
   * through the ECC listing window.
   *
   * @generated from field: string delivery_start = 4;
   */
  deliveryStart: string;

  /**
   * Net position in MW. Positive = long, negative = short. Zero positions are excluded.
   *
   * @generated from field: double net_mw = 5;
   */
  netMw: number;
};

/**
 * Describes the message devtool.emodel.v1.RawPosition.
 * Use `create(RawPositionSchema)` to create a new message.
 */
export const RawPositionSchema: GenMessage<RawPosition> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 21);

/**
 * CalculationInput is a snapshot of the data Power IM (SPAN V2) actually used
 * for its calculation. Emitted only when
 * CalculateCombinedIMRequest.with_calculation_input = true.
 *
 * Normalization policy:
 *   - psr_records: deduped per (product_id, year, month) over the PSR keys
 *     actually consulted by the calculation.
 *   - spread_records: every successful ECC pair lookup (excluding internal
 *     self-pairs), in 3-area + listing-window-clamped form.
 *   - raw_positions: positions as submitted by the caller, in their original
 *     9-area form and original (year, month) — no 3-area mapping and no
 *     listing-window clamping. Zero positions excluded; kW is converted to MW.
 *   - normalized_positions: raw_positions after 9-area → 3-area mapping and
 *     listing-window clamping, so the (year, month) lines up with
 *     spread_records. This is the form the Python reconcile tool expects.
 *
 * @generated from message devtool.emodel.v1.CalculationInput
 */
export type CalculationInput = Message<"devtool.emodel.v1.CalculationInput"> & {
  /**
   * @generated from field: repeated devtool.emodel.v1.PSRRecord psr_records = 1;
   */
  psrRecords: PSRRecord[];

  /**
   * @generated from field: repeated devtool.emodel.v1.SpreadRecord spread_records = 2;
   */
  spreadRecords: SpreadRecord[];

  /**
   * @generated from field: repeated devtool.emodel.v1.RawPosition raw_positions = 3;
   */
  rawPositions: RawPosition[];

  /**
   * Whether synthetic ECC pair generation was used. Always false today (Go has no synthetic pair generator).
   *
   * @generated from field: bool use_synthetic = 4;
   */
  useSynthetic: boolean;

  /**
   * Threshold above which credit_rate is treated as a perfect spread. Default 0.99.
   *
   * @generated from field: double perfect_credit_threshold = 5;
   */
  perfectCreditThreshold: number;

  /**
   * Positions after 9-area mapping and listing-window clamping. Same length
   * and ordering semantics as raw_positions (one entry per non-zero input
   * item; not netted).
   *
   * @generated from field: repeated devtool.emodel.v1.RawPosition normalized_positions = 6;
   */
  normalizedPositions: RawPosition[];
};

/**
 * Describes the message devtool.emodel.v1.CalculationInput.
 * Use `create(CalculationInputSchema)` to create a new message.
 */
export const CalculationInputSchema: GenMessage<CalculationInput> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_im_model, 22);

/**
 * PSRDataSource specifies the data source for Price Scan Range.
 *
 * @generated from enum devtool.emodel.v1.PSRDataSource
 */
export enum PSRDataSource {
  /**
   * @generated from enum value: PSR_DATA_SOURCE_UNSPECIFIED = 0;
   */
  PSR_DATA_SOURCE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: PSR_DATA_SOURCE_ECC_SCANNING_RANGES = 1;
   */
  PSR_DATA_SOURCE_ECC_SCANNING_RANGES = 1,

  /**
   * @generated from enum value: PSR_DATA_SOURCE_PRICE_SCANNING_RANGES = 2;
   */
  PSR_DATA_SOURCE_PRICE_SCANNING_RANGES = 2,
}

/**
 * Describes the enum devtool.emodel.v1.PSRDataSource.
 */
export const PSRDataSourceSchema: GenEnum<PSRDataSource> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_im_model, 0);

/**
 * ResultDetailLevel specifies the detail level of the result.
 *
 * @generated from enum devtool.emodel.v1.ResultDetailLevel
 */
export enum ResultDetailLevel {
  /**
   * @generated from enum value: RESULT_DETAIL_LEVEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RESULT_DETAIL_LEVEL_SUMMARY = 1;
   */
  SUMMARY = 1,

  /**
   * @generated from enum value: RESULT_DETAIL_LEVEL_DETAILED = 2;
   */
  DETAILED = 2,

  /**
   * @generated from enum value: RESULT_DETAIL_LEVEL_DEBUG = 3;
   */
  DEBUG = 3,
}

/**
 * Describes the enum devtool.emodel.v1.ResultDetailLevel.
 */
export const ResultDetailLevelSchema: GenEnum<ResultDetailLevel> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_im_model, 1);

/**
 * IMHourType represents hour types for IM calculation.
 *
 * @generated from enum devtool.emodel.v1.IMHourType
 */
export enum IMHourType {
  /**
   * @generated from enum value: IM_HOUR_TYPE_UNSPECIFIED = 0;
   */
  IM_HOUR_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: IM_HOUR_TYPE_BASE = 1;
   */
  IM_HOUR_TYPE_BASE = 1,

  /**
   * @generated from enum value: IM_HOUR_TYPE_PEAK = 2;
   */
  IM_HOUR_TYPE_PEAK = 2,
}

/**
 * Describes the enum devtool.emodel.v1.IMHourType.
 */
export const IMHourTypeSchema: GenEnum<IMHourType> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_im_model, 2);

/**
 * IMPeriodType represents period types for IM calculation.
 *
 * @generated from enum devtool.emodel.v1.IMPeriodType
 */
export enum IMPeriodType {
  /**
   * @generated from enum value: IM_PERIOD_TYPE_UNSPECIFIED = 0;
   */
  IM_PERIOD_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: IM_PERIOD_TYPE_MONTH = 1;
   */
  IM_PERIOD_TYPE_MONTH = 1,

  /**
   * @generated from enum value: IM_PERIOD_TYPE_QUARTER = 2;
   */
  IM_PERIOD_TYPE_QUARTER = 2,

  /**
   * @generated from enum value: IM_PERIOD_TYPE_SEASON = 3;
   */
  IM_PERIOD_TYPE_SEASON = 3,

  /**
   * @generated from enum value: IM_PERIOD_TYPE_FISCAL_YEAR = 4;
   */
  IM_PERIOD_TYPE_FISCAL_YEAR = 4,

  /**
   * @generated from enum value: IM_PERIOD_TYPE_CALENDAR_YEAR = 5;
   */
  IM_PERIOD_TYPE_CALENDAR_YEAR = 5,
}

/**
 * Describes the enum devtool.emodel.v1.IMPeriodType.
 */
export const IMPeriodTypeSchema: GenEnum<IMPeriodType> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_im_model, 3);

/**
 * SpanV2SpreadCreditMethod specifies how SPAN V2 pairs positions for spread credit.
 *
 * @generated from enum devtool.emodel.v1.SpanV2SpreadCreditMethod
 */
export enum SpanV2SpreadCreditMethod {
  /**
   * 未指定。SPAN_V2_SPREAD_CREDIT_METHOD_ABSOLUTE_QUANTITY（v1.0）で計算する（後方互換）。
   *
   * @generated from enum value: SPAN_V2_SPREAD_CREDIT_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * v1.0: 売買の向きを見ず、数量の絶対値でペアを組んでスプレッドクレジットを与える。
   *
   * @generated from enum value: SPAN_V2_SPREAD_CREDIT_METHOD_ABSOLUTE_QUANTITY = 1;
   */
  ABSOLUTE_QUANTITY = 1,

  /**
   * v1.1: 売買の向きが逆のペア（買いと売り）だけにスプレッドクレジットを与える。
   * ECC Derivative Market Margining v1.18 §4.1.4.3 に準拠。
   *
   * @generated from enum value: SPAN_V2_SPREAD_CREDIT_METHOD_OPPOSITE_DIRECTION = 2;
   */
  OPPOSITE_DIRECTION = 2,
}

/**
 * Describes the enum devtool.emodel.v1.SpanV2SpreadCreditMethod.
 */
export const SpanV2SpreadCreditMethodSchema: GenEnum<SpanV2SpreadCreditMethod> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_im_model, 4);

